import React from 'react';

const Documentation = () => {
  return (
    <div className="WSNG-documentation-container">
     
    </div>
  );
};

export default Documentation;
